import i18n from "i18next";
import { createRef } from "react";
import { LocalStorageConstants } from "../../constants/LocalStorageConstants";
import { SESSION_STORAGE_KEYS, ssSet } from "../../helpers/sessionStorage";
import { IRootStore } from "../../mobx/root-store";
import { TourConfig } from "../../tours/types";

/**
 * Refs for feedback reminder tour anchors.
 * Components should import and assign these refs to their elements.
 */
export const feedbackReminderTourRefs = {
	resultImage: createRef<HTMLElement>(),
};

/**
 * Creates the feedback reminder tour configuration.
 * Pass this directly to tourStore.start()
 *
 * Note: This is a function (not a constant) to ensure translations are resolved
 * at runtime when the tour starts, not at module load time.
 */
export const getFeedbackReminderTour = (): TourConfig => {
	// Translation helper - called at runtime to get current language
	const t = (key: string) => i18n.t(`playground.feedbackOverlay.${key}`, { ns: "translation" });

	return {
		name: "feedback-reminder",
		spotlightClicks: true,
		steps: [
			{
				targetRef: feedbackReminderTourRefs.resultImage,
				title: t("title"),
				content: t("content"),
				disableBeacon: true,
				placement: "bottom",
				locale: {
					last: t("buttonText"),
				},
			},
		],
		onComplete: async (_store: IRootStore) => {
			// Mark reminder as shown for this session
			ssSet(SESSION_STORAGE_KEYS.feedbackReminderShown, "true");

			// Increment the feedback reminder count
			const currentCount = Number(localStorage.getItem(LocalStorageConstants.FEEDBACK_COUNT)) || 0;
			localStorage.setItem(LocalStorageConstants.FEEDBACK_COUNT, String(currentCount + 1));
		},
		onSkip: async (_store: IRootStore) => {
			// Mark reminder as shown for this session even if skipped
			ssSet(SESSION_STORAGE_KEYS.feedbackReminderShown, "true");
		},
	};
};
